import { render } from "./loading-btn.vue?vue&type=template&id=c199ed54&scoped=true&ts=true"
import script from "./loading-btn.vue?vue&type=script&lang=ts"
export * from "./loading-btn.vue?vue&type=script&lang=ts"

import "./loading-btn.vue?vue&type=style&index=0&id=c199ed54&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c199ed54"]])

export default __exports__